<template>
  <div v-loading="loading">
    <el-row>
      <br>

      <el-form :inline="true"
               class="demo-form-inline">
        <el-form-item label="港股选择">
          <el-select value-key="symbol"
                     :popper-append-to-body=false
                     filterable
                     v-model="curConcept"
                     remote
                     :remote-method="searchStock"
                     default-first-option
                     placeholder="请输入股票名称或股票代码">
            <el-option-group label="搜索结果">
              <el-option v-for="item in stockOptions"
                         :key="item.symbol"
                         :label="item.shortName"
                         :value="item">
              </el-option>
            </el-option-group>
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-button type="primary"
                     @click="openTypeDialog(curConcept.symbol,'普通搜索')">分析一下</el-button>

        </el-form-item>
        <el-form-item>
          <el-button @click="selectDialogVisible=!selectDialogVisible">高级搜索&nbsp;&nbsp;<i class="iconfont"
               style="font-size:5px!important;color:#aaa">
              <template v-if="selectDialogVisible">
                &#xee10;
              </template>
              <template v-else>
                &#xe60f;
              </template>
            </i></el-button>
        </el-form-item>
      </el-form>
      <el-col :span="24"
              v-if="selectDialogVisible">
        <el-form :model="selectForm"
                 :inline="true">
          <el-row>

            <el-form-item label="行业">
              <el-select clearable
                         :popper-append-to-body=false
                         @change="searchStockBySelect(1)"
                         v-model="selectForm.industry"
                         filterable
                         placeholder="请选择">
                <el-option v-for="item in (hkStockLabelView&& hkStockLabelView.industryList)"
                           :key="item"
                           :label="item"
                           :value="item">
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="板块">
              <el-select clearable
                         :popper-append-to-body=false
                         @change="searchStockBySelect(1)"
                         v-model="selectForm.category"
                         filterable
                         placeholder="请选择">
                <el-option v-for="item in hkStockLabelView.forumList"
                           :key="item"
                           :label="item"
                           :value="item">
                </el-option>
              </el-select>

            </el-form-item>

            <el-form-item label="所属指数">
              <el-select clearable
                         :popper-append-to-body=false
                         @change="searchStockBySelect(1)"
                         v-model="selectForm.index"
                         filterable
                         placeholder="请选择">
                <el-option v-for="item in hkStockLabelView.indexList"
                           :key="item"
                           :label="item"
                           :value="item">
                </el-option>
              </el-select>
            </el-form-item>

          </el-row>
          <el-row>
            <el-table stripe
                      :data="searchStocks"
                      style="width: 100%">
              <span slot="empty">
                <div style="line-height:20px;">
                  <br>
                  <img src="../../../assets/imgs/emptyTable.png" />
                  <div v-if="selectForm.industry || selectForm.index || selectForm.category"> 暂无搜索记录！</div>
                  <div v-else>请设置搜索条件！</div>
                  <br>
                </div>
              </span>
              <el-table-column prop="short_name"
                               width="120"
                               label="股票">
              </el-table-column>
              <el-table-column prop="industry_name"
                               width="120"
                               label="行业">
              </el-table-column>
              <el-table-column prop="category"
                               width="100"
                               label="板块">
              </el-table-column>

              <el-table-column prop="index_name"
                               label="所属指数">
              </el-table-column>

              <el-table-column label="操作"
                               width="100">
                <template slot-scope="scope">
                  <el-button @click=" openTypeDialog(scope.row.stock_code,'高级搜索')"
                             type="text"
                             size="small">生成报告</el-button>
                </template>
              </el-table-column>
            </el-table>
            <br>
          </el-row>

          <el-row style="text-align:center"
                  v-if="searchStocks && selectForm.total > 5 ">
            <el-pagination background
                           @current-change="searchStockBySelect"
                           :currentPage="selectForm.page"
                           layout="prev, pager, next"
                           :page-size=5
                           :total="selectForm.total">
            </el-pagination>
            <br>
          </el-row>
        </el-form>
      </el-col>
    </el-row>

    <el-row style="height:calc( 100vh - 370px );overflow-y:scroll">
      <br>
      <template>
        <el-row>
          <el-col :span="14">
            <h3> AI评分&nbsp;TOP10
              <el-popover placement="right"
                          trigger="hover">
                <span style="font-size:12px;color:#999">
                  综合评分：采用多维度、量化的评分体系，由选股指标和择时指标加权构成，全面评估港<br>
                  股上市公司的竞争力、经营业绩、投资价值、市场趋势等，对港股的投资决策进行支持。<br><br>
                  财务能力：通过盈利能力、盈利质量、成长能力、偿债能力、营运能力这几个维度对港股<br>
                  上市公司的财务状况进行量化评估，体现了港股上市公司的经营情况和财务稳健程度，<br>
                  由财务角度对投资决策进行支持。
                </span>
                <i class="el-icon-question"
                   style="color:#999;font-size:14px"
                   slot="reference"></i>
              </el-popover>
              <br>
            </h3>
          </el-col>
          <el-col :span="10"
                  style="text-align:right">
            <div style="clear:both;height:25px"></div>
            <span style="color:#888;font-size:0.8em">榜单日期:&nbsp;{{hkScoreList.dataTime}}</span>
          </el-col>
        </el-row>
        <el-row>
          <el-tabs type="card">
            <el-tab-pane label="综合评分">
              <el-row>
                <el-table stripe
                          :data="JSON.parse(hkScoreList.datas||'[]')">
                  <el-table-column label="股票"
                                   prop="stockName">
                  </el-table-column>

                  <el-table-column label="AI评分"
                                   prop="score">
                  </el-table-column>
                  <el-table-column label="收盘价(HDK)"
                                   prop="ClosePrice">
                  </el-table-column>
                  <el-table-column label="涨跌幅(%)">
                    <template slot-scope="scope">
                      <template v-if="parseFloat(scope.row.ChangeRatio) > 0">
                        <span style="color:red"> {{scope.row.ChangeRatio}}</span>
                      </template>
                      <template v-if="parseFloat(scope.row.ChangeRatio) < 0">
                        <span style="color:green"> {{scope.row.ChangeRatio}}</span>
                      </template>
                      <template v-if="parseFloat(scope.row.ChangeRatio) === 0">
                        <span> {{scope.row.ChangeRatio}}</span>
                      </template>
                    </template>
                  </el-table-column>
                  <el-table-column label="总市值(亿)">
                    <template slot-scope="scope">
                      {{parseFloat(scope.row.TotalMarketValue/100000000).toFixed(2)}}
                    </template>
                  </el-table-column>
                  <el-table-column label="流通市值(亿)"
                                   prop="CirculationMarketValue">
                    <template slot-scope="scope">
                      {{parseFloat(scope.row.CirculationMarketValue/100000000).toFixed(2)}}
                    </template>
                  </el-table-column>
                  <el-table-column label="成交量(万手)"
                                   prop="TradingVolume">
                    <template slot-scope="scope">
                      {{parseFloat(scope.row.TradingVolume/10000).toFixed(2)}}
                    </template>
                  </el-table-column>
                  <el-table-column label="换手率(%)">
                    <template slot-scope="scope">
                      {{parseFloat(scope.row.TurnoverRate).toFixed(2)}}
                    </template>
                  </el-table-column>
                  <el-table-column label="操作">
                    <template slot-scope="scope">

                      <el-button @click="openTypeDialog(scope.row.Symbol,'综合评分')"
                                 type="text"
                                 size="small">生成报告</el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </el-row>
            </el-tab-pane>
            <el-tab-pane label="财务能力">
              <el-row>
                <el-table stripe
                          :data="hkFinanceList">
                  <el-table-column label="股票"
                                   prop="stockName">
                  </el-table-column>

                  <el-table-column label="财务能力评分"
                                   prop="score">
                  </el-table-column>
                  <el-table-column label="收盘价(HDK)">
                    <template slot-scope="scope">
                      {{parseFloat(scope.row.ClosePrice).toFixed(2)}}
                    </template>
                  </el-table-column>
                  <el-table-column label="涨跌幅(%)">
                    <template slot-scope="scope">
                      <template v-if="parseFloat(scope.row.ChangeRatio) > 0">
                        <span style="color:red"> {{parseFloat(scope.row.ChangeRatio).toFixed(2)}}</span>
                      </template>
                      <template v-if="parseFloat(scope.row.ChangeRatio) < 0">
                        <span style="color:green"> {{parseFloat(scope.row.ChangeRatio).toFixed(2)}}</span>
                      </template>
                      <template v-if="parseFloat(scope.row.ChangeRatio) === 0">
                        <span> {{parseFloat(scope.row.ChangeRatio).toFixed(2)}}</span>
                      </template>
                    </template>
                  </el-table-column>
                  <el-table-column label="ROA(%)">
                    <template slot-scope="scope">
                      {{parseFloat(scope.row.ROA).toFixed(2)}}
                    </template>
                  </el-table-column>
                  <el-table-column label="净现比"
                                   prop="NetCashRatio">
                  </el-table-column>
                  <el-table-column label="净利润增长率"
                                   prop="NetProfitRatio">
                  </el-table-column>
                  <el-table-column label="流动比率">
                    <template slot-scope="scope">
                      {{parseFloat(scope.row.CurrentRatio).toFixed(2)}}
                    </template>
                  </el-table-column>
                  <el-table-column label="操作">
                    <template slot-scope="scope">

                      <el-button @click="openTypeDialog(scope.row.Symbol,'财务能力')"
                                 type="text"
                                 size="small">生成报告</el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </el-row>
            </el-tab-pane>

          </el-tabs>
        </el-row>
        <el-row>
          <el-col :span="14">
            <h3> <br> 行情指标&nbsp;TOP10
            </h3>
          </el-col>
          <el-col :span="10"
                  style="text-align:right">
            <div style="clear:both;height:25px"></div><br>
            <span style="color:#888;font-size:0.8em">榜单日期:&nbsp;{{allMarketList.dataTime}}</span>
          </el-col>
        </el-row>
        <el-row>
          <el-tabs type="card">
            <el-tab-pane label="全部">
              <el-row>
                <el-form>
                  <el-form-item label="排序依据">
                    <template>
                      <el-select v-model="list_type"
                                 :popper-append-to-body=false
                                 placeholder="请选择">
                        <el-option label="涨幅榜"
                                   value="ChangeRatio">
                        </el-option>
                        <el-option label="跌幅榜"
                                   value="Change">
                        </el-option>
                        <el-option label="换手率榜"
                                   value="TurnoverRate">
                        </el-option>
                        <el-option label="市盈率榜"
                                   value="PE">
                        </el-option>
                      </el-select>
                    </template>
                  </el-form-item>
                </el-form>
              </el-row>

              <el-row>
                <el-table stripe
                          v-show="'TurnoverRate'===list_type"
                          :data="JSON.parse(allMarketList.datas ||'{}').TurnoverRate">
                  <el-table-column label="股票"
                                   prop="ShortName">
                  </el-table-column>
                  <el-table-column label="换手率(%)">
                    <template slot-scope="scope">
                      {{parseFloat(scope.row.TurnoverRate).toFixed(2)}}
                    </template>
                  </el-table-column>
                  <el-table-column label="收盘价(HDK)"
                                   prop="ClosePrice">
                  </el-table-column>
                  <el-table-column label="涨跌幅(%)">
                    <template slot-scope="scope">
                      <template v-if="parseFloat(scope.row.ChangeRatio) > 0">
                        <span style="color:red"> {{scope.row.ChangeRatio}}</span>
                      </template>
                      <template v-if="parseFloat(scope.row.ChangeRatio) < 0">
                        <span style="color:green"> {{scope.row.ChangeRatio}}</span>
                      </template>
                      <template v-if="parseFloat(scope.row.ChangeRatio) === 0">
                        <span> {{scope.row.ChangeRatio}}</span>
                      </template>
                    </template>
                  </el-table-column>
                  <el-table-column label="总市值(亿)">
                    <template slot-scope="scope">
                      {{parseFloat(scope.row.TotalMarketValue/100000000).toFixed(2)}}
                    </template>
                  </el-table-column>
                  <el-table-column label="流通市值(亿)">
                    <template slot-scope="scope">
                      {{parseFloat(scope.row.CirculationMarketValue/100000000).toFixed(2)}}
                    </template>
                  </el-table-column>
                  <el-table-column label="成交量(万手)"
                                   prop="TradingVolume">
                    <template slot-scope="scope">
                      {{parseFloat(scope.row.TradingVolume/10000).toFixed(2)}}
                    </template>
                  </el-table-column>

                  <el-table-column label="市盈率(%)"
                                   prop="PE">
                  </el-table-column>
                  <el-table-column label="操作">
                    <template slot-scope="scope">
                      <el-button @click="openTypeDialog(scope.row.Symbol,'全部股票')"
                                 type="text"
                                 size="small">生成报告</el-button>
                    </template>
                  </el-table-column>
                </el-table>
                <el-table stripe
                          v-show="'PE'===list_type"
                          ref="PE"
                          :data="JSON.parse(allMarketList.datas ||'{}').PE">
                  <el-table-column label="股票"
                                   prop="ShortName">
                  </el-table-column>
                  <el-table-column label="市盈率(%)"
                                   prop="PE">
                  </el-table-column>
                  <el-table-column label="收盘价(HDK)"
                                   prop="ClosePrice">
                  </el-table-column>
                  <el-table-column label="涨跌幅(%)">
                    <template slot-scope="scope">
                      <template v-if="parseFloat(scope.row.ChangeRatio) > 0">
                        <span style="color:red"> {{scope.row.ChangeRatio}}</span>
                      </template>
                      <template v-if="parseFloat(scope.row.ChangeRatio) < 0">
                        <span style="color:green"> {{scope.row.ChangeRatio}}</span>
                      </template>
                      <template v-if="parseFloat(scope.row.ChangeRatio) === 0">
                        <span> {{scope.row.ChangeRatio}}</span>
                      </template>
                    </template>
                  </el-table-column>
                  <el-table-column label="总市值(亿)">
                    <template slot-scope="scope">
                      {{parseFloat(scope.row.TotalMarketValue/100000000).toFixed(2)}}
                    </template>
                  </el-table-column>
                  <el-table-column label="流通市值(亿)">
                    <template slot-scope="scope">
                      {{parseFloat(scope.row.CirculationMarketValue/100000000).toFixed(2)}}
                    </template>
                  </el-table-column>
                  <el-table-column label="成交量(万手)"
                                   prop="TradingVolume">
                    <template slot-scope="scope">
                      {{parseFloat(scope.row.TradingVolume/10000).toFixed(2)}}
                    </template>
                  </el-table-column>
                  <el-table-column label="换手率(%)">
                    <template slot-scope="scope">
                      <!-- {{scope.row}} -->
                      {{parseFloat(scope.row.TurnoverRate).toFixed(2)}}
                    </template>
                  </el-table-column>
                  <el-table-column label="操作">
                    <template slot-scope="scope">
                      <el-button @click="openTypeDialog(scope.row.Symbol,'全部股票')"
                                 type="text"
                                 size="small">生成报告</el-button>
                    </template>
                  </el-table-column>
                </el-table>
                <el-table stripe
                          v-show="'Change'===list_type"
                          :data="JSON.parse(allMarketList.datas ||'{}').Change">
                  <el-table-column label="股票"
                                   prop="ShortName">
                  </el-table-column>

                  <el-table-column label="收盘价(HDK)"
                                   prop="ClosePrice">
                  </el-table-column>
                  <el-table-column label="涨跌幅(%)">
                    <template slot-scope="scope">
                      <template v-if="parseFloat(scope.row.ChangeRatio) > 0">
                        <span style="color:red"> {{scope.row.ChangeRatio}}</span>
                      </template>
                      <template v-if="parseFloat(scope.row.ChangeRatio) < 0">
                        <span style="color:green"> {{scope.row.ChangeRatio}}</span>
                      </template>
                      <template v-if="parseFloat(scope.row.ChangeRatio) === 0">
                        <span> {{scope.row.ChangeRatio}}</span>
                      </template>
                    </template>
                  </el-table-column>
                  <el-table-column label="总市值(亿)">
                    <template slot-scope="scope">
                      {{parseFloat(scope.row.TotalMarketValue/100000000).toFixed(2)}}
                    </template>
                  </el-table-column>
                  <el-table-column label="流通市值(亿)">
                    <template slot-scope="scope">
                      {{parseFloat(scope.row.CirculationMarketValue/100000000).toFixed(2)}}
                    </template>
                  </el-table-column>
                  <el-table-column label="成交量(万手)"
                                   prop="TradingVolume">
                    <template slot-scope="scope">
                      {{parseFloat(scope.row.TradingVolume/10000).toFixed(2)}}
                    </template>
                  </el-table-column>
                  <el-table-column label="换手率(%)">
                    <template slot-scope="scope">
                      {{parseFloat(scope.row.TurnoverRate).toFixed(2)}}
                    </template>
                  </el-table-column>
                  <el-table-column label="市盈率(%)"
                                   prop="PE">
                  </el-table-column>
                  <el-table-column label="操作">
                    <template slot-scope="scope">
                      <el-button @click="openTypeDialog(scope.row.Symbol,'全部股票')"
                                 type="text"
                                 size="small">生成报告</el-button>
                    </template>
                  </el-table-column>
                </el-table>
                <el-table stripe
                          v-show="'ChangeRatio'===list_type"
                          :data="JSON.parse(allMarketList.datas ||'{}').ChangeRatio">
                  <el-table-column label="股票"
                                   prop="ShortName">
                  </el-table-column>

                  <el-table-column label="收盘价(HDK)"
                                   prop="ClosePrice">
                  </el-table-column>
                  <el-table-column label="涨跌幅(%)">
                    <template slot-scope="scope">
                      <template v-if="parseFloat(scope.row.ChangeRatio) > 0">
                        <span style="color:red"> {{scope.row.ChangeRatio}}</span>
                      </template>
                      <template v-if="parseFloat(scope.row.ChangeRatio) < 0">
                        <span style="color:green"> {{scope.row.ChangeRatio}}</span>
                      </template>
                      <template v-if="parseFloat(scope.row.ChangeRatio) === 0">
                        <span> {{scope.row.ChangeRatio}}</span>
                      </template>
                    </template>
                  </el-table-column>
                  <el-table-column label="总市值(亿)">
                    <template slot-scope="scope">
                      {{parseFloat(scope.row.TotalMarketValue/100000000).toFixed(2)}}
                    </template>
                  </el-table-column>
                  <el-table-column label="流通市值(亿)">
                    <template slot-scope="scope">
                      {{parseFloat(scope.row.CirculationMarketValue/100000000).toFixed(2)}}
                    </template>
                  </el-table-column>
                  <el-table-column label="成交量(万手)"
                                   prop="TradingVolume">
                    <template slot-scope="scope">
                      {{parseFloat(scope.row.TradingVolume/10000).toFixed(2)}}
                    </template>
                  </el-table-column>
                  <el-table-column label="换手率(%)">
                    <template slot-scope="scope">
                      {{parseFloat(scope.row.TurnoverRate).toFixed(2)}}
                    </template>
                  </el-table-column>
                  <el-table-column label="市盈率(%)"
                                   prop="PE">
                  </el-table-column>
                  <el-table-column label="操作">
                    <template slot-scope="scope">
                      <el-button @click="openTypeDialog(scope.row.Symbol,'全部股票')"
                                 type="text"
                                 size="small">生成报告</el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </el-row>
            </el-tab-pane>
            <el-tab-pane label="红筹股">
              <el-row>
                <el-form>
                  <el-form-item label="排序依据">
                    <template>
                      <el-select v-model="red_type"
                                 :popper-append-to-body=false
                                 placeholder="请选择">
                        <el-option label="涨幅榜"
                                   value="ChangeRatio">
                        </el-option>
                        <el-option label="跌幅榜"
                                   value="Change">
                        </el-option>
                        <el-option label="换手率榜"
                                   value="TurnoverRate">
                        </el-option>
                        <el-option label="市盈率榜"
                                   value="PE">
                        </el-option>

                      </el-select>
                    </template>
                  </el-form-item>
                </el-form>
              </el-row>

              <el-row>
                <el-table stripe
                          v-show="'TurnoverRate'===red_type"
                          :data="redMarketList.TurnoverRate">
                  <el-table-column label="股票"
                                   prop="ShortName">
                  </el-table-column>
                  <el-table-column label="换手率(%)">
                    <template slot-scope="scope">
                      {{parseFloat(scope.row.TurnoverRate).toFixed(2)}}
                    </template>
                  </el-table-column>
                  <el-table-column label="收盘价(HDK)"
                                   prop="ClosePrice">
                  </el-table-column>
                  <el-table-column label="涨跌幅(%)">
                    <template slot-scope="scope">
                      <template v-if="parseFloat(scope.row.ChangeRatio) > 0">
                        <span style="color:red"> {{scope.row.ChangeRatio}}</span>
                      </template>
                      <template v-if="parseFloat(scope.row.ChangeRatio) < 0">
                        <span style="color:green"> {{scope.row.ChangeRatio}}</span>
                      </template>
                      <template v-if="parseFloat(scope.row.ChangeRatio) === 0">
                        <span> {{scope.row.ChangeRatio}}</span>
                      </template>
                    </template>
                  </el-table-column>
                  <el-table-column label="总市值(亿)">
                    <template slot-scope="scope">
                      {{parseFloat(scope.row.TotalMarketValue/100000000).toFixed(2)}}
                    </template>
                  </el-table-column>
                  <el-table-column label="流通市值(亿)">
                    <template slot-scope="scope">
                      {{parseFloat(scope.row.CirculationMarketValue/100000000).toFixed(2)}}
                    </template>
                  </el-table-column>
                  <el-table-column label="成交量(万手)"
                                   prop="TradingVolume">
                    <template slot-scope="scope">
                      {{parseFloat(scope.row.TradingVolume/10000).toFixed(2)}}
                    </template>
                  </el-table-column>

                  <el-table-column label="市盈率(%)"
                                   prop="PE">
                  </el-table-column>
                  <el-table-column label="操作">
                    <template slot-scope="scope">
                      <el-button @click="openTypeDialog(scope.row.Symbol,'全部股票')"
                                 type="text"
                                 size="small">生成报告</el-button>
                    </template>
                  </el-table-column>
                </el-table>
                <el-table stripe
                          v-show="'PE'===red_type"
                          ref="PE"
                          :data="redMarketList.PE">
                  <el-table-column label="股票"
                                   prop="ShortName">
                  </el-table-column>
                  <el-table-column label="市盈率(%)"
                                   prop="PE">
                  </el-table-column>
                  <el-table-column label="收盘价(HDK)"
                                   prop="ClosePrice">
                  </el-table-column>
                  <el-table-column label="涨跌幅(%)">
                    <template slot-scope="scope">
                      <template v-if="parseFloat(scope.row.ChangeRatio) > 0">
                        <span style="color:red"> {{scope.row.ChangeRatio}}</span>
                      </template>
                      <template v-if="parseFloat(scope.row.ChangeRatio) < 0">
                        <span style="color:green"> {{scope.row.ChangeRatio}}</span>
                      </template>
                      <template v-if="parseFloat(scope.row.ChangeRatio) === 0">
                        <span> {{scope.row.ChangeRatio}}</span>
                      </template>
                    </template>
                  </el-table-column>
                  <el-table-column label="总市值(亿)">
                    <template slot-scope="scope">
                      {{parseFloat(scope.row.TotalMarketValue/100000000).toFixed(2)}}
                    </template>
                  </el-table-column>
                  <el-table-column label="流通市值(亿)">
                    <template slot-scope="scope">
                      {{parseFloat(scope.row.CirculationMarketValue/100000000).toFixed(2)}}
                    </template>
                  </el-table-column>
                  <el-table-column label="成交量(万手)"
                                   prop="TradingVolume">
                    <template slot-scope="scope">
                      {{parseFloat(scope.row.TradingVolume/10000).toFixed(2)}}
                    </template>
                  </el-table-column>
                  <el-table-column label="换手率(%)">
                    <template slot-scope="scope">
                      <!-- {{scope.row}} -->
                      {{parseFloat(scope.row.TurnoverRate).toFixed(2)}}
                    </template>
                  </el-table-column>
                  <el-table-column label="操作">
                    <template slot-scope="scope">
                      <el-button @click="openTypeDialog(scope.row.Symbol,'全部股票')"
                                 type="text"
                                 size="small">生成报告</el-button>
                    </template>
                  </el-table-column>
                </el-table>
                <el-table stripe
                          v-show="'Change'===red_type "
                          :data="redMarketList.Change">
                  <el-table-column label="股票"
                                   prop="ShortName">
                  </el-table-column>

                  <el-table-column label="收盘价(HDK)"
                                   prop="ClosePrice">
                  </el-table-column>
                  <el-table-column label="涨跌幅(%)">
                    <template slot-scope="scope">
                      <template v-if="parseFloat(scope.row.ChangeRatio) > 0">
                        <span style="color:red"> {{scope.row.ChangeRatio}}</span>
                      </template>
                      <template v-if="parseFloat(scope.row.ChangeRatio) < 0">
                        <span style="color:green"> {{scope.row.ChangeRatio}}</span>
                      </template>
                      <template v-if="parseFloat(scope.row.ChangeRatio) === 0">
                        <span> {{scope.row.ChangeRatio}}</span>
                      </template>
                    </template>
                  </el-table-column>
                  <el-table-column label="总市值(亿)">
                    <template slot-scope="scope">
                      {{parseFloat(scope.row.TotalMarketValue/100000000).toFixed(2)}}
                    </template>
                  </el-table-column>
                  <el-table-column label="流通市值(亿)">
                    <template slot-scope="scope">
                      {{parseFloat(scope.row.CirculationMarketValue/100000000).toFixed(2)}}
                    </template>
                  </el-table-column>
                  <el-table-column label="成交量(万手)"
                                   prop="TradingVolume">
                    <template slot-scope="scope">
                      {{parseFloat(scope.row.TradingVolume/10000).toFixed(2)}}
                    </template>
                  </el-table-column>
                  <el-table-column label="换手率(%)">
                    <template slot-scope="scope">
                      {{parseFloat(scope.row.TurnoverRate).toFixed(2)}}
                    </template>
                  </el-table-column>
                  <el-table-column label="市盈率(%)"
                                   prop="PE">
                  </el-table-column>
                  <el-table-column label="操作">
                    <template slot-scope="scope">
                      <el-button @click="openTypeDialog(scope.row.Symbol,'全部股票')"
                                 type="text"
                                 size="small">生成报告</el-button>
                    </template>
                  </el-table-column>
                </el-table>
                <el-table stripe
                          v-show=" 'ChangeRatio'===red_type"
                          :data="redMarketList.ChangeRatio">
                  <el-table-column label="股票"
                                   prop="ShortName">
                  </el-table-column>

                  <el-table-column label="收盘价(HDK)"
                                   prop="ClosePrice">
                  </el-table-column>
                  <el-table-column label="涨跌幅(%)">
                    <template slot-scope="scope">
                      <template v-if="parseFloat(scope.row.ChangeRatio) > 0">
                        <span style="color:red"> {{scope.row.ChangeRatio}}</span>
                      </template>
                      <template v-if="parseFloat(scope.row.ChangeRatio) < 0">
                        <span style="color:green"> {{scope.row.ChangeRatio}}</span>
                      </template>
                      <template v-if="parseFloat(scope.row.ChangeRatio) === 0">
                        <span> {{scope.row.ChangeRatio}}</span>
                      </template>
                    </template>
                  </el-table-column>
                  <el-table-column label="总市值(亿)">
                    <template slot-scope="scope">
                      {{parseFloat(scope.row.TotalMarketValue/100000000).toFixed(2)}}
                    </template>
                  </el-table-column>
                  <el-table-column label="流通市值(亿)">
                    <template slot-scope="scope">
                      {{parseFloat(scope.row.CirculationMarketValue/100000000).toFixed(2)}}
                    </template>
                  </el-table-column>
                  <el-table-column label="成交量(万手)"
                                   prop="TradingVolume">
                    <template slot-scope="scope">
                      {{parseFloat(scope.row.TradingVolume/10000).toFixed(2)}}
                    </template>
                  </el-table-column>
                  <el-table-column label="换手率(%)">
                    <template slot-scope="scope">
                      {{parseFloat(scope.row.TurnoverRate).toFixed(2)}}
                    </template>
                  </el-table-column>
                  <el-table-column label="市盈率(%)"
                                   prop="PE">
                  </el-table-column>
                  <el-table-column label="操作">
                    <template slot-scope="scope">
                      <el-button @click="openTypeDialog(scope.row.Symbol,'全部股票')"
                                 type="text"
                                 size="small">生成报告</el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </el-row>
            </el-tab-pane>
            <el-tab-pane label="蓝筹股">
              <el-row>
                <el-form>
                  <el-form-item label="排序依据">
                    <template>
                      <el-select v-model="blue_type"
                                 :popper-append-to-body=false
                                 placeholder="请选择">
                        <el-option label="涨幅榜"
                                   value="ChangeRatio">
                        </el-option>
                        <el-option label="跌幅榜"
                                   value="Change">
                        </el-option>
                        <el-option label="换手率榜"
                                   value="TurnoverRate">
                        </el-option>
                        <el-option label="市盈率榜"
                                   value="PE">
                        </el-option>

                      </el-select>
                    </template>
                  </el-form-item>
                </el-form>
              </el-row>
              <el-row>
                <el-table stripe
                          v-show="'TurnoverRate'===blue_type"
                          ref="TurnoverRate"
                          :data="blueMarketList.TurnoverRate">
                  <el-table-column label="股票"
                                   prop="ShortName">
                  </el-table-column>
                  <el-table-column label="换手率(%)">
                    <template slot-scope="scope">
                      {{parseFloat(scope.row.TurnoverRate).toFixed(2)}}
                    </template>
                  </el-table-column>
                  <el-table-column label="收盘价(HDK)"
                                   prop="ClosePrice">
                  </el-table-column>
                  <el-table-column label="涨跌幅(%)">
                    <template slot-scope="scope">
                      <template v-if="parseFloat(scope.row.ChangeRatio) > 0">
                        <span style="color:red"> {{scope.row.ChangeRatio}}</span>
                      </template>
                      <template v-if="parseFloat(scope.row.ChangeRatio) < 0">
                        <span style="color:green"> {{scope.row.ChangeRatio}}</span>
                      </template>
                      <template v-if="parseFloat(scope.row.ChangeRatio) === 0">
                        <span> {{scope.row.ChangeRatio}}</span>
                      </template>
                    </template>
                  </el-table-column>
                  <el-table-column label="总市值(亿)">
                    <template slot-scope="scope">
                      {{parseFloat(scope.row.TotalMarketValue/100000000).toFixed(2)}}
                    </template>
                  </el-table-column>
                  <el-table-column label="流通市值(亿)">
                    <template slot-scope="scope">
                      {{parseFloat(scope.row.CirculationMarketValue/100000000).toFixed(2)}}
                    </template>
                  </el-table-column>
                  <el-table-column label="成交量(万手)"
                                   prop="TradingVolume">
                    <template slot-scope="scope">
                      {{parseFloat(scope.row.TradingVolume/10000).toFixed(2)}}
                    </template>
                  </el-table-column>

                  <el-table-column label="市盈率(%)"
                                   prop="PE">
                  </el-table-column>
                  <el-table-column label="操作">
                    <template slot-scope="scope">
                      <el-button @click="openTypeDialog(scope.row.Symbol,'全部股票')"
                                 type="text"
                                 size="small">生成报告</el-button>
                    </template>
                  </el-table-column>
                </el-table>
                <el-table stripe
                          v-show="'PE'===blue_type"
                          ref="PE"
                          :data="blueMarketList.PE">
                  <el-table-column label="股票"
                                   prop="ShortName">
                  </el-table-column>
                  <el-table-column label="市盈率(%)"
                                   prop="PE">
                  </el-table-column>
                  <el-table-column label="收盘价(HDK)"
                                   prop="ClosePrice">
                  </el-table-column>
                  <el-table-column label="涨跌幅(%)">
                    <template slot-scope="scope">
                      <template v-if="parseFloat(scope.row.ChangeRatio) > 0">
                        <span style="color:red"> {{scope.row.ChangeRatio}}</span>
                      </template>
                      <template v-if="parseFloat(scope.row.ChangeRatio) < 0">
                        <span style="color:green"> {{scope.row.ChangeRatio}}</span>
                      </template>
                      <template v-if="parseFloat(scope.row.ChangeRatio) === 0">
                        <span> {{scope.row.ChangeRatio}}</span>
                      </template>
                    </template>
                  </el-table-column>
                  <el-table-column label="总市值(亿)">
                    <template slot-scope="scope">
                      {{parseFloat(scope.row.TotalMarketValue/100000000).toFixed(2)}}
                    </template>
                  </el-table-column>
                  <el-table-column label="流通市值(亿)">
                    <template slot-scope="scope">
                      {{parseFloat(scope.row.CirculationMarketValue/100000000).toFixed(2)}}
                    </template>
                  </el-table-column>
                  <el-table-column label="成交量(万手)"
                                   prop="TradingVolume">
                    <template slot-scope="scope">
                      {{parseFloat(scope.row.TradingVolume/10000).toFixed(2)}}
                    </template>
                  </el-table-column>
                  <el-table-column label="换手率(%)">
                    <template slot-scope="scope">
                      <!-- {{scope.row}} -->
                      {{parseFloat(scope.row.TurnoverRate).toFixed(2)}}
                    </template>
                  </el-table-column>
                  <el-table-column label="操作">
                    <template slot-scope="scope">
                      <el-button @click="openTypeDialog(scope.row.Symbol,'全部股票')"
                                 type="text"
                                 size="small">生成报告</el-button>
                    </template>
                  </el-table-column>
                </el-table>
                <el-table stripe
                          v-show="'Change'===blue_type "
                          :data="blueMarketList.Change">
                  <el-table-column label="股票"
                                   prop="ShortName">
                  </el-table-column>

                  <el-table-column label="收盘价(HDK)"
                                   prop="ClosePrice">
                  </el-table-column>
                  <el-table-column label="涨跌幅(%)">
                    <template slot-scope="scope">
                      <template v-if="parseFloat(scope.row.ChangeRatio) > 0">
                        <span style="color:red"> {{scope.row.ChangeRatio}}</span>
                      </template>
                      <template v-if="parseFloat(scope.row.ChangeRatio) < 0">
                        <span style="color:green"> {{scope.row.ChangeRatio}}</span>
                      </template>
                      <template v-if="parseFloat(scope.row.ChangeRatio) === 0">
                        <span> {{scope.row.ChangeRatio}}</span>
                      </template>
                    </template>
                  </el-table-column>
                  <el-table-column label="总市值(亿)">
                    <template slot-scope="scope">
                      {{parseFloat(scope.row.TotalMarketValue/100000000).toFixed(2)}}
                    </template>
                  </el-table-column>
                  <el-table-column label="流通市值(亿)">
                    <template slot-scope="scope">
                      {{parseFloat(scope.row.CirculationMarketValue/100000000).toFixed(2)}}
                    </template>
                  </el-table-column>
                  <el-table-column label="成交量(万手)"
                                   prop="TradingVolume">
                    <template slot-scope="scope">
                      {{parseFloat(scope.row.TradingVolume/10000).toFixed(2)}}
                    </template>
                  </el-table-column>
                  <el-table-column label="换手率(%)">
                    <template slot-scope="scope">
                      {{parseFloat(scope.row.TurnoverRate).toFixed(2)}}
                    </template>
                  </el-table-column>
                  <el-table-column label="市盈率(%)"
                                   prop="PE">
                  </el-table-column>
                  <el-table-column label="操作">
                    <template slot-scope="scope">
                      <el-button @click="openTypeDialog(scope.row.Symbol,'全部股票')"
                                 type="text"
                                 size="small">生成报告</el-button>
                    </template>
                  </el-table-column>
                </el-table>
                <el-table stripe
                          v-show=" 'ChangeRatio'===blue_type"
                          :data="blueMarketList.ChangeRatio">
                  <el-table-column label="股票"
                                   prop="ShortName">
                  </el-table-column>

                  <el-table-column label="收盘价(HDK)"
                                   prop="ClosePrice">
                  </el-table-column>
                  <el-table-column label="涨跌幅(%)">
                    <template slot-scope="scope">
                      <template v-if="parseFloat(scope.row.ChangeRatio) > 0">
                        <span style="color:red"> {{scope.row.ChangeRatio}}</span>
                      </template>
                      <template v-if="parseFloat(scope.row.ChangeRatio) < 0">
                        <span style="color:green"> {{scope.row.ChangeRatio}}</span>
                      </template>
                      <template v-if="parseFloat(scope.row.ChangeRatio) === 0">
                        <span> {{scope.row.ChangeRatio}}</span>
                      </template>
                    </template>
                  </el-table-column>
                  <el-table-column label="总市值(亿)">
                    <template slot-scope="scope">
                      {{parseFloat(scope.row.TotalMarketValue/100000000).toFixed(2)}}
                    </template>
                  </el-table-column>
                  <el-table-column label="流通市值(亿)">
                    <template slot-scope="scope">
                      {{parseFloat(scope.row.CirculationMarketValue/100000000).toFixed(2)}}
                    </template>
                  </el-table-column>
                  <el-table-column label="成交量(万手)"
                                   prop="TradingVolume">
                    <template slot-scope="scope">
                      {{parseFloat(scope.row.TradingVolume/10000).toFixed(2)}}
                    </template>
                  </el-table-column>
                  <el-table-column label="换手率(%)">
                    <template slot-scope="scope">
                      {{parseFloat(scope.row.TurnoverRate).toFixed(2)}}
                    </template>
                  </el-table-column>
                  <el-table-column label="市盈率(%)"
                                   prop="PE">
                  </el-table-column>
                  <el-table-column label="操作">
                    <template slot-scope="scope">
                      <el-button @click="openTypeDialog(scope.row.Symbol,'全部股票')"
                                 type="text"
                                 size="small">生成报告</el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </el-row>
            </el-tab-pane>
            <el-tab-pane label="国企股">
              <el-row>
                <el-form>
                  <el-form-item label="排序依据">
                    <template>
                      <el-select v-model="contry_type"
                                 :popper-append-to-body=false
                                 placeholder="请选择">
                        <el-option label="涨幅榜"
                                   value="ChangeRatio">
                        </el-option>
                        <el-option label="跌幅榜"
                                   value="Change">
                        </el-option>
                        <el-option label="换手率榜"
                                   value="TurnoverRate">
                        </el-option>
                        <el-option label="市盈率榜"
                                   value="PE">
                        </el-option>
                      </el-select>
                    </template>
                  </el-form-item>
                </el-form>
              </el-row>
              <el-row>
                <el-table stripe
                          v-show="'TurnoverRate'===contry_type"
                          :data="contryMarketList.TurnoverRate">
                  <el-table-column label="股票"
                                   prop="ShortName">
                  </el-table-column>
                  <el-table-column label="换手率(%)">
                    <template slot-scope="scope">
                      {{parseFloat(scope.row.TurnoverRate).toFixed(2)}}
                    </template>
                  </el-table-column>
                  <el-table-column label="收盘价(HDK)"
                                   prop="ClosePrice">
                  </el-table-column>
                  <el-table-column label="涨跌幅(%)">
                    <template slot-scope="scope">
                      <template v-if="parseFloat(scope.row.ChangeRatio) > 0">
                        <span style="color:red"> {{scope.row.ChangeRatio}}</span>
                      </template>
                      <template v-if="parseFloat(scope.row.ChangeRatio) < 0">
                        <span style="color:green"> {{scope.row.ChangeRatio}}</span>
                      </template>
                      <template v-if="parseFloat(scope.row.ChangeRatio) === 0">
                        <span> {{scope.row.ChangeRatio}}</span>
                      </template>
                    </template>
                  </el-table-column>
                  <el-table-column label="总市值(亿)">
                    <template slot-scope="scope">
                      {{parseFloat(scope.row.TotalMarketValue/100000000).toFixed(2)}}
                    </template>
                  </el-table-column>
                  <el-table-column label="流通市值(亿)">
                    <template slot-scope="scope">
                      {{parseFloat(scope.row.CirculationMarketValue/100000000).toFixed(2)}}
                    </template>
                  </el-table-column>
                  <el-table-column label="成交量(万手)"
                                   prop="TradingVolume">
                    <template slot-scope="scope">
                      {{parseFloat(scope.row.TradingVolume/10000).toFixed(2)}}
                    </template>
                  </el-table-column>

                  <el-table-column label="市盈率(%)"
                                   prop="PE">
                  </el-table-column>
                  <el-table-column label="操作">
                    <template slot-scope="scope">
                      <el-button @click="openTypeDialog(scope.row.Symbol,'全部股票')"
                                 type="text"
                                 size="small">生成报告</el-button>
                    </template>
                  </el-table-column>
                </el-table>
                <el-table stripe
                          v-show="'PE'===contry_type"
                          :data="contryMarketList.PE">
                  <el-table-column label="股票"
                                   prop="ShortName">
                  </el-table-column>
                  <el-table-column label="市盈率(%)"
                                   prop="PE">
                  </el-table-column>
                  <el-table-column label="收盘价(HDK)"
                                   prop="ClosePrice">
                  </el-table-column>
                  <el-table-column label="涨跌幅(%)">
                    <template slot-scope="scope">
                      <template v-if="parseFloat(scope.row.ChangeRatio) > 0">
                        <span style="color:red"> {{scope.row.ChangeRatio}}</span>
                      </template>
                      <template v-if="parseFloat(scope.row.ChangeRatio) < 0">
                        <span style="color:green"> {{scope.row.ChangeRatio}}</span>
                      </template>
                      <template v-if="parseFloat(scope.row.ChangeRatio) === 0">
                        <span> {{scope.row.ChangeRatio}}</span>
                      </template>
                    </template>
                  </el-table-column>
                  <el-table-column label="总市值(亿)">
                    <template slot-scope="scope">
                      {{parseFloat(scope.row.TotalMarketValue/100000000).toFixed(2)}}
                    </template>
                  </el-table-column>
                  <el-table-column label="流通市值(亿)">
                    <template slot-scope="scope">
                      {{parseFloat(scope.row.CirculationMarketValue/100000000).toFixed(2)}}
                    </template>
                  </el-table-column>
                  <el-table-column label="成交量(万手)"
                                   prop="TradingVolume">
                    <template slot-scope="scope">
                      {{parseFloat(scope.row.TradingVolume/10000).toFixed(2)}}
                    </template>
                  </el-table-column>
                  <el-table-column label="换手率(%)">
                    <template slot-scope="scope">
                      <!-- {{scope.row}} -->
                      {{parseFloat(scope.row.TurnoverRate).toFixed(2)}}
                    </template>
                  </el-table-column>
                  <el-table-column label="操作">
                    <template slot-scope="scope">
                      <el-button @click="openTypeDialog(scope.row.Symbol,'全部股票')"
                                 type="text"
                                 size="small">生成报告</el-button>
                    </template>
                  </el-table-column>
                </el-table>
                <el-table stripe
                          v-show="'Change'===contry_type "
                          :data="contryMarketList.Change">
                  <el-table-column label="股票"
                                   prop="ShortName">
                  </el-table-column>

                  <el-table-column label="收盘价(HDK)"
                                   prop="ClosePrice">
                  </el-table-column>
                  <el-table-column label="涨跌幅(%)">
                    <template slot-scope="scope">
                      <template v-if="parseFloat(scope.row.ChangeRatio) > 0">
                        <span style="color:red"> {{scope.row.ChangeRatio}}</span>
                      </template>
                      <template v-if="parseFloat(scope.row.ChangeRatio) < 0">
                        <span style="color:green"> {{scope.row.ChangeRatio}}</span>
                      </template>
                      <template v-if="parseFloat(scope.row.ChangeRatio) === 0">
                        <span> {{scope.row.ChangeRatio}}</span>
                      </template>
                    </template>
                  </el-table-column>
                  <el-table-column label="总市值(亿)">
                    <template slot-scope="scope">
                      {{parseFloat(scope.row.TotalMarketValue/100000000).toFixed(2)}}
                    </template>
                  </el-table-column>
                  <el-table-column label="流通市值(亿)">
                    <template slot-scope="scope">
                      {{parseFloat(scope.row.CirculationMarketValue/100000000).toFixed(2)}}
                    </template>
                  </el-table-column>
                  <el-table-column label="成交量(万手)"
                                   prop="TradingVolume">
                    <template slot-scope="scope">
                      {{parseFloat(scope.row.TradingVolume/10000).toFixed(2)}}
                    </template>
                  </el-table-column>
                  <el-table-column label="换手率(%)">
                    <template slot-scope="scope">
                      {{parseFloat(scope.row.TurnoverRate).toFixed(2)}}
                    </template>
                  </el-table-column>
                  <el-table-column label="市盈率(%)"
                                   prop="PE">
                  </el-table-column>
                  <el-table-column label="操作">
                    <template slot-scope="scope">
                      <el-button @click="openTypeDialog(scope.row.Symbol,'全部股票')"
                                 type="text"
                                 size="small">生成报告</el-button>
                    </template>
                  </el-table-column>
                </el-table>
                <el-table stripe
                          v-show=" 'ChangeRatio'===contry_type"
                          :data="contryMarketList.ChangeRatio">
                  <el-table-column label="股票"
                                   prop="ShortName">
                  </el-table-column>

                  <el-table-column label="收盘价(HDK)"
                                   prop="ClosePrice">
                  </el-table-column>
                  <el-table-column label="涨跌幅(%)">
                    <template slot-scope="scope">
                      <template v-if="parseFloat(scope.row.ChangeRatio) > 0">
                        <span style="color:red"> {{scope.row.ChangeRatio}}</span>
                      </template>
                      <template v-if="parseFloat(scope.row.ChangeRatio) < 0">
                        <span style="color:green"> {{scope.row.ChangeRatio}}</span>
                      </template>
                      <template v-if="parseFloat(scope.row.ChangeRatio) === 0">
                        <span> {{scope.row.ChangeRatio}}</span>
                      </template>
                    </template>
                  </el-table-column>
                  <el-table-column label="总市值(亿)">
                    <template slot-scope="scope">
                      {{parseFloat(scope.row.TotalMarketValue/100000000).toFixed(2)}}
                    </template>
                  </el-table-column>
                  <el-table-column label="流通市值(亿)">
                    <template slot-scope="scope">
                      {{parseFloat(scope.row.CirculationMarketValue/100000000).toFixed(2)}}
                    </template>
                  </el-table-column>
                  <el-table-column label="成交量(万手)"
                                   prop="TradingVolume">
                    <template slot-scope="scope">
                      {{parseFloat(scope.row.TradingVolume/10000).toFixed(2)}}
                    </template>
                  </el-table-column>
                  <el-table-column label="换手率(%)">
                    <template slot-scope="scope">
                      {{parseFloat(scope.row.TurnoverRate).toFixed(2)}}
                    </template>
                  </el-table-column>
                  <el-table-column label="市盈率(%)"
                                   prop="PE">
                  </el-table-column>
                  <el-table-column label="操作">
                    <template slot-scope="scope">
                      <el-button @click="openTypeDialog(scope.row.Symbol,'全部股票')"
                                 type="text"
                                 size="small">生成报告</el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </el-row>
            </el-tab-pane>

            <el-tab-pane label="创业板">
              <el-row>
                <el-form>
                  <el-form-item label="排序依据">
                    <template>
                      <el-select v-model="growth_type"
                                 :popper-append-to-body=false
                                 placeholder="请选择">
                        <el-option label="涨幅榜"
                                   value="ChangeRatio">
                        </el-option>
                        <el-option label="跌幅榜"
                                   value="Change">
                        </el-option>
                        <el-option label="换手率榜"
                                   value="TurnoverRate">
                        </el-option>
                        <el-option label="市盈率榜"
                                   value="PE">
                        </el-option>
                      </el-select>
                    </template>
                  </el-form-item>
                </el-form>
              </el-row>
              <el-row>
                <el-table stripe
                          v-show="'TurnoverRate'===growth_type"
                          :data="growthMarketList.TurnoverRate">
                  <el-table-column label="股票"
                                   prop="ShortName">
                  </el-table-column>
                  <el-table-column label="换手率(%)">
                    <template slot-scope="scope">
                      {{parseFloat(scope.row.TurnoverRate).toFixed(2)}}
                    </template>
                  </el-table-column>
                  <el-table-column label="收盘价(HDK)"
                                   prop="ClosePrice">
                  </el-table-column>
                  <el-table-column label="涨跌幅(%)">
                    <template slot-scope="scope">
                      <template v-if="parseFloat(scope.row.ChangeRatio) > 0">
                        <span style="color:red"> {{scope.row.ChangeRatio}}</span>
                      </template>
                      <template v-if="parseFloat(scope.row.ChangeRatio) < 0">
                        <span style="color:green"> {{scope.row.ChangeRatio}}</span>
                      </template>
                      <template v-if="parseFloat(scope.row.ChangeRatio) === 0">
                        <span> {{scope.row.ChangeRatio}}</span>
                      </template>
                    </template>
                  </el-table-column>
                  <el-table-column label="总市值(亿)">
                    <template slot-scope="scope">
                      {{parseFloat(scope.row.TotalMarketValue/100000000).toFixed(2)}}
                    </template>
                  </el-table-column>
                  <el-table-column label="流通市值(亿)">
                    <template slot-scope="scope">
                      {{parseFloat(scope.row.CirculationMarketValue/100000000).toFixed(2)}}
                    </template>
                  </el-table-column>
                  <el-table-column label="成交量(万手)"
                                   prop="TradingVolume">
                    <template slot-scope="scope">
                      {{parseFloat(scope.row.TradingVolume/10000).toFixed(2)}}
                    </template>
                  </el-table-column>

                  <el-table-column label="市盈率(%)"
                                   prop="PE">
                  </el-table-column>
                  <el-table-column label="操作">
                    <template slot-scope="scope">
                      <el-button @click="openTypeDialog(scope.row.Symbol,'全部股票')"
                                 type="text"
                                 size="small">生成报告</el-button>
                    </template>
                  </el-table-column>
                </el-table>
                <el-table stripe
                          v-show="'PE'===growth_type"
                          :data="growthMarketList.PE">
                  <el-table-column label="股票"
                                   prop="ShortName">
                  </el-table-column>
                  <el-table-column label="市盈率(%)"
                                   prop="PE">
                  </el-table-column>
                  <el-table-column label="收盘价(HDK)"
                                   prop="ClosePrice">
                  </el-table-column>
                  <el-table-column label="涨跌幅(%)">
                    <template slot-scope="scope">
                      <template v-if="parseFloat(scope.row.ChangeRatio) > 0">
                        <span style="color:red"> {{scope.row.ChangeRatio}}</span>
                      </template>
                      <template v-if="parseFloat(scope.row.ChangeRatio) < 0">
                        <span style="color:green"> {{scope.row.ChangeRatio}}</span>
                      </template>
                      <template v-if="parseFloat(scope.row.ChangeRatio) === 0">
                        <span> {{scope.row.ChangeRatio}}</span>
                      </template>
                    </template>
                  </el-table-column>
                  <el-table-column label="总市值(亿)">
                    <template slot-scope="scope">
                      {{parseFloat(scope.row.TotalMarketValue/100000000).toFixed(2)}}
                    </template>
                  </el-table-column>
                  <el-table-column label="流通市值(亿)">
                    <template slot-scope="scope">
                      {{parseFloat(scope.row.CirculationMarketValue/100000000).toFixed(2)}}
                    </template>
                  </el-table-column>
                  <el-table-column label="成交量(万手)"
                                   prop="TradingVolume">
                    <template slot-scope="scope">
                      {{parseFloat(scope.row.TradingVolume/10000).toFixed(2)}}
                    </template>
                  </el-table-column>
                  <el-table-column label="换手率(%)">
                    <template slot-scope="scope">
                      <!-- {{scope.row}} -->
                      {{parseFloat(scope.row.TurnoverRate).toFixed(2)}}
                    </template>
                  </el-table-column>
                  <el-table-column label="操作">
                    <template slot-scope="scope">
                      <el-button @click="openTypeDialog(scope.row.Symbol,'全部股票')"
                                 type="text"
                                 size="small">生成报告</el-button>
                    </template>
                  </el-table-column>
                </el-table>
                <el-table stripe
                          v-show="'Change'===growth_type"
                          :data="growthMarketList.Change">
                  <el-table-column label="股票"
                                   prop="ShortName">
                  </el-table-column>

                  <el-table-column label="收盘价(HDK)"
                                   prop="ClosePrice">
                  </el-table-column>
                  <el-table-column label="涨跌幅(%)">
                    <template slot-scope="scope">
                      <template v-if="parseFloat(scope.row.ChangeRatio) > 0">
                        <span style="color:red"> {{scope.row.ChangeRatio}}</span>
                      </template>
                      <template v-if="parseFloat(scope.row.ChangeRatio) < 0">
                        <span style="color:green"> {{scope.row.ChangeRatio}}</span>
                      </template>
                      <template v-if="parseFloat(scope.row.ChangeRatio) === 0">
                        <span> {{scope.row.ChangeRatio}}</span>
                      </template>
                    </template>
                  </el-table-column>
                  <el-table-column label="总市值(亿)">
                    <template slot-scope="scope">
                      {{parseFloat(scope.row.TotalMarketValue/100000000).toFixed(2)}}
                    </template>
                  </el-table-column>
                  <el-table-column label="流通市值(亿)">
                    <template slot-scope="scope">
                      {{parseFloat(scope.row.CirculationMarketValue/100000000).toFixed(2)}}
                    </template>
                  </el-table-column>
                  <el-table-column label="成交量(万手)"
                                   prop="TradingVolume">
                    <template slot-scope="scope">
                      {{parseFloat(scope.row.TradingVolume/10000).toFixed(2)}}
                    </template>
                  </el-table-column>
                  <el-table-column label="换手率(%)">
                    <template slot-scope="scope">
                      {{parseFloat(scope.row.TurnoverRate).toFixed(2)}}
                    </template>
                  </el-table-column>
                  <el-table-column label="市盈率(%)"
                                   prop="PE">
                  </el-table-column>
                  <el-table-column label="操作">
                    <template slot-scope="scope">
                      <el-button @click="openTypeDialog(scope.row.Symbol,'全部股票')"
                                 type="text"
                                 size="small">生成报告</el-button>
                    </template>
                  </el-table-column>
                </el-table>
                <el-table stripe
                          v-show=" 'ChangeRatio'===growth_type"
                          :data="growthMarketList.ChangeRatio">
                  <el-table-column label="股票"
                                   prop="ShortName">
                  </el-table-column>

                  <el-table-column label="收盘价(HDK)"
                                   prop="ClosePrice">
                  </el-table-column>
                  <el-table-column label="涨跌幅(%)">
                    <template slot-scope="scope">
                      <template v-if="parseFloat(scope.row.ChangeRatio) > 0">
                        <span style="color:red"> {{scope.row.ChangeRatio}}</span>
                      </template>
                      <template v-if="parseFloat(scope.row.ChangeRatio) < 0">
                        <span style="color:green"> {{scope.row.ChangeRatio}}</span>
                      </template>
                      <template v-if="parseFloat(scope.row.ChangeRatio) === 0">
                        <span> {{scope.row.ChangeRatio}}</span>
                      </template>
                    </template>
                  </el-table-column>
                  <el-table-column label="总市值(亿)">
                    <template slot-scope="scope">
                      {{parseFloat(scope.row.TotalMarketValue/100000000).toFixed(2)}}
                    </template>
                  </el-table-column>
                  <el-table-column label="流通市值(亿)">
                    <template slot-scope="scope">
                      {{parseFloat(scope.row.CirculationMarketValue/100000000).toFixed(2)}}
                    </template>
                  </el-table-column>
                  <el-table-column label="成交量(万手)"
                                   prop="TradingVolume">
                    <template slot-scope="scope">
                      {{parseFloat(scope.row.TradingVolume/10000).toFixed(2)}}
                    </template>
                  </el-table-column>
                  <el-table-column label="换手率(%)">
                    <template slot-scope="scope">
                      {{parseFloat(scope.row.TurnoverRate).toFixed(2)}}
                    </template>
                  </el-table-column>
                  <el-table-column label="市盈率(%)"
                                   prop="PE">
                  </el-table-column>
                  <el-table-column label="操作">
                    <template slot-scope="scope">
                      <el-button @click="openTypeDialog(scope.row.Symbol,'全部股票')"
                                 type="text"
                                 size="small">生成报告</el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </el-row>

            </el-tab-pane>
          </el-tabs>
        </el-row>

        <el-row>
          <el-col :span="14">
            <h3><br>AH比价
            </h3>
          </el-col>
          <el-col :span="10"
                  style="text-align:right">
            <div style="clear:both;height:25px"></div><br>
            <span style="color:#888;font-size:0.8em">榜单日期:&nbsp;{{aHComparsionList.tradingDate}}</span>
          </el-col>
        </el-row>
        <el-row>
          <el-table stripe
                    :data="aHComparsionList.ahComparators">
            <el-table-column label="股票"
                             prop="Name">
            </el-table-column>
            <el-table-column label="H股代码"
                             prop="Symbol">
            </el-table-column>
            <el-table-column label="现价(HDK)"
                             prop="ClosePrice">
            </el-table-column>
            <el-table-column label="A股代码"
                             prop="ASymbol">
            </el-table-column>
            <el-table-column label="现价(RMB)"
                             prop="AClosePrice">
            </el-table-column>

            <el-table-column label="比价(A/H)"
                             prop="Comparsion">
            </el-table-column>
            <el-table-column label="溢价(A/H)%"
                             prop="Premium">
            </el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button @click="openTypeDialog(scope.row.Symbol,'AH比价')"
                           type="text"
                           size="small">生成报告</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-row>
        <el-row style="text-align:center">
          <br>
          <el-pagination background
                         @current-change="getAhCompare"
                         layout="prev, pager, next"
                         :total="aHComparsionList.total">
          </el-pagination>
        </el-row>
      </template>
    </el-row>
    <!--类型选择框-->
    <el-dialog width="500px"
               :visible.sync="fileTypeDialogVisible">
      <div class="c_p"
           slot="title"><b>{{(stockName)||'港股分析'}}</b></div>
      <el-form>

        <el-form-item label="文件类型">
          <template>
            <el-radio v-model="fileType"
                      label="PDF">PDF</el-radio>
            <el-radio v-model="fileType"
                      label="DOC">word</el-radio>
          </template>
        </el-form-item>
        <span>请注意，选择【生成】即扣除报告下载次数,<br>
          若当前账户内没有剩余下载次数，可以购买单篇报告，<br>或者点击右上角【会员套餐】购买超值套餐</span>
      </el-form>
      <div slot="footer"
           class="dialog-footer">
        <el-button @click="fileTypeDialogVisible = false">取 消</el-button>
        <el-button type="primary"
                   @click="inputGenConcept">生 成</el-button>
      </div>
    </el-dialog>

    <el-dialog width="500"
               top="0"
               :close-on-click-modal=false
               :visible.sync="pdfDialogVisible">
      <iframe :src="pdfUrl+'#toolbar=0'"
              style="width: 100%;height: calc(100vh - 120px);border: 0;" />
      <div style="text-align:center">
        <el-button @click="toDownPdf(curSourceId)"
                   size="small">下载</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import axios from 'axios'
import pay from '../../pay'
import moment from 'moment'
export default {
  name: 'ele',
  data: function () {
    return {
      curConcept: {},
      reportType: 'SIMPLE',
      fileType: 'PDF',
      options: [],

      pdfUrl: '',
      loading: false,

      pdfDialogVisible: false,
      tabsName: 'concept',

      curSourceId: '',
      typeDialogVisible: false,
      list_type: 'ChangeRatio',
      red_type: 'ChangeRatio',
      blue_type: 'ChangeRatio',
      contry_type: 'ChangeRatio',
      growth_type: 'ChangeRatio',
      stockOptions: [],
      candidateConcept: [],
      conceptUpDlowList: {
        column: {}
      },

      stockCode: '',
      stockName: '',
      searchLogs: [],

      fileTypeDialogVisible: false,
      conceptSearchLogs: [],
      payDialogVisible: false,
      curReport: {},
      reportId: '',
      selectDialogVisible: false,
      searchTimer: null,
      conceptOfStockRes: [],
      hkStockList: [],
      hkScoreList: [],
      allMarketList: {},
      redMarketList: {},
      blueMarketList: {},
      contryMarketList: {},
      growthMarketList: {},
      aHComparsionList: {},
      hkFinanceList: [],
      hkStockLabelView: {},
      selectForm: {},
      searchStocks: []
    }
  },

  components: {
    pay
  },

  watch: {
    payResult: function () {
      let _this = this
      this.payDialogVisible = false
      if (this.curReport && this.curReport.fileType === 'DOC') {
        window.open('/api/web/stock/downLoadReport/' + this.curReport.sourceId)
      } else {
        _this.pdfUrl = '/api/web/stock/readPdf/' + this.sourceId
        _this.pdfDialogVisible = true
      }
    }
  },

  filters: {
    dateFilter: function (v) {
      return moment(new Date(parseInt(v))).format('YYYY-MM-DD')
    }
  },

  computed: {
    payResult () {
      return this.$store.state.payResult
    },
    userInfo: function () {
      let temp = localStorage.getItem('userinfo')
      if (temp) {
        return JSON.parse(temp)
      }
      return null
    },
    accountinfo: function () {
      let temp = localStorage.getItem('accountinfo')
      if (temp) {
        return JSON.parse(temp)
      }
      return {}
    }
  },
  methods: {
    searchStockBySelect (p) {
      this.selectForm.page = p
      let _this = this
      if (
        !this.selectForm.category &&
        !this.selectForm.index &&
        !this.selectForm.industry) {
        _this.searchStocks = []
        _this.selectForm.total = 0
        return
      }
      axios.post('/api/web/stock/searchHkStock', this.selectForm).then(resp => {
        _this.searchStocks = resp.data.records
        _this.selectForm.total = parseInt(resp.data.total)
      })
    },
    inputGenConcept () {
      let _this = this
      _this.fileTypeDialogVisible = false
      this.loading = true
      axios.get('/api/web/report/genReport/' + _this.fileType + '/HKSTOCK/' + this.stockCode).then(resp => {
        _this.pdfUrl = ''
        _this.reportId = resp.data.id
        _this.$store.commit('toFreshUserPrice')
        _this.getReportStatus()
      }).catch(e => {
        _this.loading = false
        if (e.code === 401) {
          _this.$alert(e.msg, '您的使用次数已超过限制，需要更多权限，请联系客服。')
        }
      })
    },
    getReportStatus () {
      let _this = this
      axios.get('/api/web/stock/reportInfo/' + _this.reportId).then(resp => {
        _this.loading = true
        if (resp.data.status === 'DOING') {
          _this.loading = true
          setTimeout(() => {
            _this.getReportStatus(_this.reportId)
          }, 2000)
        } else if (resp.data.status === 'FINISH') {
          _this.loading = false
          _this.sourceId = resp.data.sourceId
          if (resp.data.fileType === 'PDF') {
            _this.pdfDialogVisible = true
            _this.pdfUrl = '/api/web/stock/readPdf/' + this.sourceId
            _this.pdfDialogVisible = true
          } else {
            _this.toDownPdf()
          }
        } else {
          _this.loading = false
          _this.$notify.error({
            title: '失败',
            message: '报告生成失败，请稍候重试。'
          })
        }
      })
    },

    showSearchLogs () {
      this.options = this.searchLogs
    },
    showConceptSearchLogs () {
      this.stockOptions = this.conceptSearchLogs
    },

    searchStock (query) {
      let _this = this
      if (query !== '') {
        setTimeout(() => {
          _this.stockOptions = _this.hkStockList.filter(item => {
            return ((item.shortName.toLowerCase().indexOf(query.toLowerCase()) > -1) || (item.symbol.toLowerCase().indexOf(query.toLowerCase()) > -1) || (item.pinYin.toLowerCase().indexOf(query.toLowerCase()) > -1))
          })
        }, 200)
      } else {
        this.stockOptions = []
      }
    },
    openTypeDialog (code) {
      if (!code) {
        this.$message.error('请选择股票')
        return
      }
      this.stockCode = code
      let _this = this
      _this.hkStockList.forEach(i => {
        if (i.symbol === code) {
          _this.stockName = i.shortName
        }
      })

      this.fileTypeDialogVisible = true
    },

    toDownPdf () {
      window.open('/api/web/stock/downLoadReport/' + this.sourceId)
    },

    toRead (sourceId) {
      let _this = this
      _this.pdfUrl = '/api/web/stock/readPdf/' + sourceId
      _this.pdfDialogVisible = true
    },
    getAhCompare (page) {
      if (!page) {
        page = 1
      }
      let _this = this
      axios.get('/api/web/stock/aHComparsionList?page=' + page).then(resp => {
        _this.aHComparsionList = resp.data
      })
    }
  },

  mounted () {
    let _this = this
    try {
      this.hkStockList = JSON.parse(localStorage.getItem('hkStockList'))
      this.hkScoreList = JSON.parse(localStorage.getItem('hkScoreList'))
      this.hkFinanceList = JSON.parse(localStorage.getItem('hkFinanceList'))
      this.allMarketList = JSON.parse(localStorage.getItem('allMarketList'))
      this.redMarketList = JSON.parse(localStorage.getItem('redMarketList'))
      this.blueMarketList = JSON.parse(localStorage.getItem('blueMarketList'))
      this.contryMarketList = JSON.parse(localStorage.getItem('contryMarketList'))
      this.growthMarketList = JSON.parse(localStorage.getItem('growthMarketList'))
      this.hkStockLabelView = JSON.parse(localStorage.getItem('hkStockLabelView'))
    } catch (e) {
      console.error(e)
    }
    axios.get('/api/web/stock/hkStockList').then(resp => {
      localStorage.setItem('hkStockList', JSON.stringify(resp.data))
      _this.hkStockList = resp.data
    })
    axios.get('/api/web/stock/hkScoreList').then(resp => {
      localStorage.setItem('hkScoreList', JSON.stringify(resp.data))
      _this.hkScoreList = resp.data
    })
    axios.get('/api/web/stock/hkFinanceList').then(resp => {
      localStorage.setItem('hkFinanceList', JSON.stringify(resp.data))
      _this.hkFinanceList = resp.data
    })
    axios.get('/api/web/stock/allMarketList').then(resp => {
      localStorage.setItem('allMarketList', JSON.stringify(resp.data))
      _this.allMarketList = resp.data
    })
    axios.get('/api/web/stock/redMarketList').then(resp => {
      localStorage.setItem('redMarketList', JSON.stringify(resp.data))
      _this.redMarketList = resp.data
    })
    axios.get('/api/web/stock/blueMarketList').then(resp => {
      localStorage.setItem('blueMarketList', JSON.stringify(resp.data))
      _this.blueMarketList = resp.data
    })
    axios.get('/api/web/stock/contryMarketList').then(resp => {
      localStorage.setItem('contryMarketList', JSON.stringify(resp.data))
      _this.contryMarketList = resp.data
    })
    axios.get('/api/web/stock/growthMarketList').then(resp => {
      localStorage.setItem('growthMarketList', JSON.stringify(resp.data))
      _this.growthMarketList = resp.data
    })

    axios.get('/api/web/stock/hkStockLabelView').then(resp => {
      localStorage.setItem('hkStockLabelView', JSON.stringify(resp.data))
      _this.hkStockLabelView = resp.data || {}
    })

    this.getAhCompare(1)
  }
}
</script>
<style lang="less" scoped>
.openCloseIframe {
  border: 0px;
  width: 603px;
  height: calc(100vh - 203px);
}
.container-fluid {
  background: url('/static/img/courses-header.jpg');
  height: 400px;
}
.mydropzone {
  background: #0000;
  border: dashed 2px #fff6;
  border-radius: 10px;
  top: 50%;
  position: relative;
}
.mydropzone:focus {
  background: #0000 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/index/hk/stock.vue